import React from "react"
import { Button, Dropdown, Typography } from "@mimber/ui-web"
import { MoreOutlined, DeleteOutlined } from "@mimber/ui-web"
import { usePermissionedMenuItems } from "@/core/hooks/usePermissionedMenuItems"
import { useRemoveGroupMemberModal } from "@/components/modals"
import { Resource, Action } from "@mimber/schema"
import type { PermissionedMenuItem } from "@/core/hooks/usePermissionedMenuItems/usePermissionedMenuItems.types"
import type { MemberGroupActionsDropdownProps } from "./MemberGroupActionsDropdown.types"

const { Text } = Typography

export const MemberGroupActionsDropdown: React.FunctionComponent<
  MemberGroupActionsDropdownProps
> = ({
  member,
  onActionComplete,
  size = "small",
  type = "text",
  iconOnly = true,
}) => {
  const { contextHolder, showRemoveGroupMemberModal } =
    useRemoveGroupMemberModal()

  const handleRemove = () => {
    showRemoveGroupMemberModal({
      member,
      groupUuid: member.group?.uuid,
      onConfirm: () => {
        onActionComplete?.()
      },
    })
  }

  const getActionMenuItems = (): PermissionedMenuItem[] => {
    return [
      {
        key: "remove",
        label: "Remove",
        icon: <DeleteOutlined />,
        danger: true,
        resource: Resource.GROUP,
        action: Action.DELETE,
        onClick: handleRemove,
      },
    ]
  }

  const { items: menuItems } = usePermissionedMenuItems({
    items: getActionMenuItems(),
  })

  if (menuItems.length === 0) {
    return <Text type="secondary">—</Text>
  }

  return (
    <>
      {contextHolder}
      <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
        <Button
          type={type}
          icon={iconOnly ? <MoreOutlined /> : undefined}
          size={size}
          data-testid={`member-group-actions-${member.uuid}`}
        >
          {!iconOnly && "Actions"}
        </Button>
      </Dropdown>
    </>
  )
}
